import React, { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { saveInputValue } from '@redux/search';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useDebounce } from 'react-use';

import BamOnlineWhiteLogo from 'assets/logo-bam-online-white.svg';
import BamLogo from 'assets/logo-bam.png';
import { showBamOnlineFeature } from 'services/helpers/featureToggle';

import { BamLogoAppBarContainer, StyledHelpLink, SearchBar, SearchInput } from './Header.style';

const SEARCH_DELAY = 650;

const Header: React.FC<{
  className?: string;
  hasLogoBarHeader: boolean;
  isHelpLinkDisplayed: boolean;
}> = ({ className, hasLogoBarHeader, isHelpLinkDisplayed }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState('');

  useDebounce(
    () => {
      dispatch(saveInputValue(inputValue));
    },
    SEARCH_DELAY,
    [inputValue],
  );

  return (
    <div className={className}>
      <BamLogoAppBarContainer position='relative'>
        {hasLogoBarHeader ? (
          <>
            {showBamOnlineFeature() ? (
              <img src={BamOnlineWhiteLogo} height='90%' alt='' />
            ) : (
              <img src={BamLogo} height='100%' alt='' />
            )}
            {isHelpLinkDisplayed && <StyledHelpLink />}
          </>
        ) : (
          <SearchBar>
            <SearchInput
              value={inputValue}
              onChange={(event) => setInputValue(event.target.value)}
              placeholder={intl.formatMessage({ id: 'home.search-input-placeholder' })}
              startAdornment={
                <InputAdornment position='start'>
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </SearchBar>
        )}
      </BamLogoAppBarContainer>
    </div>
  );
};

export default Header;
